/** Enum pictureSystemType из Swagger POST /organization/media/pictures */
export const ORGANIZATION_COMPOSITION_MEDIA_PICTURE_SYSTEM_TYPE = "ORGANIZATION_COMPOSITION_MEDIA";
export const TEXTURE_PICTURE_SYSTEM_TYPE = "TEXTURE";
